export default __webpack_public_path__ + "static/media/testify13.5390a78e.png";